var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.items, function(item) {
      return _c(
        "v-list",
        { key: item.id, staticClass: "purchased" },
        [
          _c(
            "v-list-item",
            { class: item.paymentStatus },
            [
              item.category === "addons" || item.category === "ow"
                ? [
                    _c("v-list-item-content", [
                      _vm._v(
                        "\n\n\t\t\t\t\t" +
                          _vm._s(item.name) +
                          " $" +
                          _vm._s(item.price) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]
                : item.category === "merch"
                ? [
                    _c("v-list-item-content", [
                      _vm._v(
                        "\n\n\t\t\t\t\t" +
                          _vm._s(item.name) +
                          " " +
                          _vm._s(item.m_l) +
                          " " +
                          _vm._s(item.colour) +
                          " " +
                          _vm._s(item.size) +
                          " $" +
                          _vm._s(item.price) +
                          "\n\n\t\t\t\t"
                      )
                    ])
                  ]
                : item.category === "tips"
                ? [
                    _c("v-list-item-content", [
                      _vm._v(
                        "\n\n\t\t\t\t\t" +
                          _vm._s(item.name) +
                          " " +
                          _vm._s(item.notes) +
                          " $" +
                          _vm._s(item.price) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]
                : item.category === "split"
                ? [
                    _c("v-list-item-content", [
                      _vm._v(
                        "\n\n\t\t\t\t\t" +
                          _vm._s(item.notes) +
                          " $" +
                          _vm._s(item.price) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-list-item-avatar",
                [
                  item.paymentStatus === "paid" && _vm.status >= 2
                    ? _c(
                        "v-avatar",
                        { attrs: { tile: "" } },
                        [
                          item.category != "ow" &&
                          item.category != "pckg" &&
                          item.category != "split"
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.voidItem(item)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("mdi-cash-refund")])],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.paymentStatus == "pending"
                    ? _c(
                        "v-avatar",
                        { attrs: { tile: "" } },
                        [
                          item.category != "ow" &&
                          item.category != "pckg" &&
                          item.category != "split"
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "red--text",
                                  attrs: { icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteItem(item)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("mdi-delete-forever")])],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }